import { render, staticRenderFns } from "./wjnoset.vue?vue&type=template&id=b5073bce&scoped=true"
import script from "./wjnoset.vue?vue&type=script&lang=js"
export * from "./wjnoset.vue?vue&type=script&lang=js"
import style0 from "./wjnoset.vue?vue&type=style&index=0&id=b5073bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5073bce",
  null
  
)

export default component.exports